(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const syncFooterGroups = (isMobile) => {
    document.querySelectorAll('.pfs-footer__group').forEach((group) => {
      group.open = !isMobile;
    });
  };

  const initialize = () => {
    syncFooterGroups(mobileQuery.matches);

    const onBreakpointChange = (event) => {
      syncFooterGroups(event.matches);
    };

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', onBreakpointChange);
    } else {
      mobileQuery.addListener(onBreakpointChange);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
